<template>
  <div class="feedback-container">
    <v-card class="feedback-card">
      <!-- 標題與描述 -->
      <h2 class="feedback-title">請填寫您寶貴的意見</h2>
      <p class="feedback-subtitle"><span class="text-red">*</span> 為必填欄位</p>

      <v-form v-model="formValid">
        <!-- 問題 1: 如何稱呼您 -->
        <div class="form-group">
          <label class="question-title">如何稱呼您呢？<span class="text-red">*</span></label>
          <v-text-field
            v-model="form.name"
            outlined
            required
            class="feedback-input"
            :rules="[rules.required]"
          ></v-text-field>
        </div>

        <!-- 問題 2: 您的電子郵件 -->
        <div class="form-group">
          <label class="question-title">您的電子郵件<span class="text-red">*</span></label>
          <v-text-field
            v-model="form.email"
            type="email"
            outlined
            required
            class="feedback-input"
            :rules="[rules.required, rules.email]"
          ></v-text-field>
        </div>

        <!-- 問題 3: 意見分類 (下拉選單) -->
        <div class="form-group">
          <label class="question-title">意見分類<span class="text-red">*</span></label>
          <v-select
            v-model="form.category"
            :items="categories"
            outlined
            required
            class="feedback-input"
            :rules="[rules.required]"
          ></v-select>
        </div>

        <!-- 問題 4: 您的意見 -->
        <div class="form-group">
          <label class="question-title">您的意見<span class="text-red">*</span></label>
          <v-textarea
            v-model="form.comment"
            outlined
            required
            rows="5"
            class="feedback-input"
            :rules="[rules.required]"
          ></v-textarea>
        </div>

        <!-- 提交與重置按鈕 -->
        <div class="feedback-buttons">
          <v-btn outlined class="reset-button" @click="resetForm">重新填寫</v-btn>
          <v-btn
            :disabled="!formValid"
            color="success"
            class="submit-button"
            @click="submitForm"
          >
            送出
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        category: "",
        comment: "",
      },
      formValid: false,
      categories: [
        "機器人驗證失敗",
        "收不到驗證信",
        "短網址申請流程",
        "其他",
        "為團隊加油點個讚",
      ],
      rules: {
        required: (value) => !!value || "此欄位為必填",
        email: (value) =>
          /.+@.+\..+/.test(value) || "請輸入有效的電子郵件地址",
      },
    };
  },
  methods: {
    resetForm() {
      this.form = {
        name: "",
        email: "",
        category: "",
        comment: "",
      };
      this.formValid = false;
    },
    submitForm() {
      if (this.formValid) {
        console.log("表單已提交:", this.form);
        alert("感謝您的意見！");
        this.resetForm();
      }
    },
  },
};
</script>

<style scoped>
.feedback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(to bottom right, #ffffff);
  padding: 20px;
}

.feedback-card {
  width: 100%;
  max-width: 500px;
  padding: 30px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.feedback-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.feedback-subtitle {
  text-align: center;
  color: #989898;
  font-size: 14px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.question-title {
  display: block;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.feedback-input {
  width: 100%;
}

.feedback-buttons {
  display: flex;
  justify-content: space-between;
}

.reset-button {
  color: #333;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  font-size: 16px;
}

.submit-button {
  font-size: 16px;
  color: white;
  background-color: #4caf50;
}

@media (max-width: 768px) {
  .feedback-card {
    padding: 20px;
  }

  .feedback-title {
    font-size: 20px;
  }

  .feedback-input {
    font-size: 14px;
  }

  .feedback-buttons {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
